import axios from 'axios';

/**
 * 
 * @param {*} params 
 */
export function signupViaSNS(queryParams) {
    return new Promise((resolve, reject) => {
        let url = `${process.env.API_BASE_URL}user/register`,
            config = {
                headers: {
                    token: process.env.UNIQUE_TOKEN,
                }
            };

        axios.post(url, queryParams, config)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            });
    })
}



// WEBPACK FOOTER //
// ./src/api/sns-user.js